import { useMutation } from '@apollo/client';
import { ConfirmationModal } from '@ovComponents/3-pattern/confirmationDialog/confirmationDialog';
import { Button } from 'hephaestus/web';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GO_TO_STEP } from '../queries';

export const RegenerateForms = ({
  workflowCompletion,
  setActiveWorkflowCompletion,
}: {
  workflowCompletion: any;
  setActiveWorkflowCompletion?: (workflowCompletion: any) => void;
}) => {
  const { t } = useTranslation(['workflowCompletions']);
  const [open, setOpen] = useState(false);
  const [goToStep, { loading: goToStepLoading }] = useMutation(GO_TO_STEP());

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = async () => {
    const prepareSubStep = (workflowCompletion?.workflow?.steps ?? [])
      .flatMap((step: any) => step.subSteps ?? [])
      .find((subStep: any) => subStep.type === 'PREPARE_FORM_COMPLETIONS');

    if (!prepareSubStep) {
      handleClose();
      return;
    }

    const { data } = await goToStep({
      variables: {
        input: {
          workflowCompletionId: workflowCompletion.id,
          subStepId: prepareSubStep.id,
        },
      },
    });

    const nextWorkflowCompletion = data?.goToSubStep?.workflowCompletion;
    if (!nextWorkflowCompletion) {
      handleClose();
      return;
    }
    // Tack a one-shot flag onto the active workflowCompletion so the next
    // mount of PrepareFormCompletions reads it and sends `forcePrepare: true`.
    // The flag naturally disappears on the next setActiveWorkflowCompletion
    // (e.g. when nextStep advances out of PREPARE), the same pattern used for
    // `direction: 'FORWARD' | 'BACKWARD'` in workflowCompletion.tsx.
    setActiveWorkflowCompletion?.({
      ...nextWorkflowCompletion,
      forcePrepareFormCompletions: true,
    });
    handleClose();
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        variant='contained'
        size='small'
        data-testid='regenerate-forms-button'
        color='secondary'
      >
        {t('workflowCompletions:regenerateForms.button')}
      </Button>
      <ConfirmationModal
        open={open}
        title={t('workflowCompletions:regenerateForms.title')}
        bodyText={t('workflowCompletions:regenerateForms.body')}
        confirmButtonLabel={t('workflowCompletions:regenerateForms.confirm')}
        cancelButtonLabel={t('workflowCompletions:regenerateForms.cancel')}
        confirmButtonColor='error'
        confirmButtonVariant='contained'
        cancelButtonVariant='outlined'
        loading={goToStepLoading}
        onConfirm={handleConfirm}
        onCancel={handleClose}
        testIdPrefix='regenerate-forms-modal'
      />
    </>
  );
};
